// @see {@link ../configuration/README.md}
export const DefaultJsonConfiguration = {
    /**
     * Key of property representing ID of the entity.
     * If set to null, the property won't be used.
     */
    jsonIdKeyAlias: "id",
    /**
     * Whether the property @id is required.
     */
    jsonIdRequired: true,
    /**
     * Key of property representing the type of the entity.
     * If set to null, the property won't be used.
     */
    jsonTypeKeyAlias: "type",
    /**
     * Whether the property @type is required.
     */
    jsonTypeRequired: true,
    /**
     * Value of @base json-ld property in context.
     */
    jsonLdBaseUrl: null,
    /**
     * How to treat root objects cardinality.
     * - "single" - root object is a single object
     * - "array" - root object is an array of objects
     * - "object-with-array" - root object is an object with a single property which is an array of objects. The name of the property is defined by {jsonRootCardinalityObjectKey}
     */
    jsonRootCardinality: "single",
    /**
     * Name of the property in root object which contains array of objects.
     * This is used only if {jsonRootCardinality === "object-with-array"}
     */
    jsonRootCardinalityObjectKey: "items",
    /**
     * How types of JSON objects are reresented.
     */
    jsonDefaultTypeKeyMapping: "human-label",
    /**
     * Language used for label if {jsonDefaultTypeKeyMapping === "human-label"}
     */
    jsonDefaultTypeKeyMappingHumanLabelLang: "cs",
    /**
     * Preferred language used for labels and descriptions.
     */
    jsonLabelLanguage: "cs",
    /**
     * Whether JSON schemas shall be dereferenced, meaning that all $ref will be resolved.
     */
    dereferenceSchema: false,
    dereferenceContext: false,
    includeContextInExample: true,
};
export class JsonConfigurator {
    static KEY = "json";
    static getFromObject(configurationObject) {
        return configurationObject?.[JsonConfigurator.KEY] ?? {};
    }
    static setToObject(configurationObject, options) {
        return { ...configurationObject, [JsonConfigurator.KEY]: options };
    }
    static merge(...options) {
        let result = {};
        for (const option of options) {
            result = { ...result, ...option };
        }
        return result;
    }
    static getDefault() {
        return DefaultJsonConfiguration;
    }
}
//# sourceMappingURL=configuration.js.map